var map = {
	"./BOU/instore.png": "cfd9",
	"./DRU/instore.png": "b867",
	"./FNB/instore.png": "7d1c",
	"./HIM/instore.png": "31ef",
	"./SUP/instore.png": "b7f0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8846";